<template>
    <div>
        <div id="paycor-container"></div>
    </div>
</template>

<script setup>
import { onMounted } from 'vue';

onMounted(() => {
    if (!document.getElementById('gnewtonjs')) {
        const script = document.createElement('script');
        script.id = 'gnewtonjs';
        script.type = 'text/javascript';
        script.src = 'https://recruitingbypaycor.com/career/iframe.action?clientId=8a7883c68006174501800ad154e00298';
        document.getElementById('paycor-container')?.appendChild(script);
    }
});
</script>
<style>
#paycor-container {
    margin-top: 65px;
    width: 100%;
    padding: 20px;
    background-color: #f9f9f9;
}
</style>